<template>
  <svg
    class="c-icon"
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    :viewBox="viewBox"
    :aria-label="icon.name"
    @click="$emit('click')"
    role="img"
  >
    <g :fill="fill" :stroke="stroke" v-html="icon.path"></g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: [Number, String],
      default: 16
    },
    height: {
      type: [Number, String],
      default: 16
    },
    color: {
      type: String
    },
    opt: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      icon: {
        name: "check",
        path: `<path d="M4.20001 7.1C4.00001 7.1 3.90001 7.1 3.70001 7L0.500011 4.6C0.200011 4.4 0.100011 3.9 0.400011 3.5C0.600011 3.2 1.10001 3.1 1.40001 3.4L4.10001 5.4L8.40001 1.1C8.70001 0.8 9.20001 0.8 9.50001 1.1C9.80001 1.4 9.80001 1.9 9.50001 2.2L4.70001 7C4.60001 7.1 4.40001 7.1 4.20001 7.1Z" />`,
        fill: "#FFFFFF",
        viewBox: "0 0 10 8"
      }
    };
  },
  computed: {
    option() {
      if (!this.opt) return {};
      return this.opt;
    },
    fill() {
      if (!this.icon || !this.icon.fill) return undefined;
      if (this.icon.fill == "#FFF") return this.icon.fill;
      if (!this.color) return this.icon.fill;
      return this.color;
    },
    stroke() {
      if (!this.icon || !this.icon.stroke) return undefined;
      if (this.icon.stroke == "#FFF") return this.icon.stroke;
      if (!this.color) return this.icon.stroke;
      return this.color;
    },
    viewBox() {
      if (!this.icon.viewBox) return "0 0 24 24";
      return this.icon.viewBox;
    }
  }
};
</script>

<style scoped></style>
